import React, { FC, PropsWithChildren } from "react";

import styled from "styled-components";
import MUITabs from "@mui/material/Tabs";

import { breakpoints } from "@/styles/breakpoints";

type TabsProps = {
    value: any;
    [x: string]: any;
};

const Tabs: FC<PropsWithChildren<TabsProps>> = styled((props) => {
    return <MUITabs {...props} classes={{ indicator: "indicator" }} TabIndicatorProps={{ children: <div /> }} />;
})`
    && {
        width: 90%;
        min-width: auto;

        @media ${breakpoints.xs} {
            width: 91%;
        }
    }

    && .indicator {
        display: none;
    }
`;

export default Tabs;
